import { ActionCreatorProps, props } from '@ngrx/store';

export type ActionFncs<S, F> = {
  successFnc?: ({ ...args }?: any) => void;
  failFnc?: ({ ...args }?: F) => void;
  bypassLoader?: boolean;
};

export function baseProps<P, S = {}, F = {}>(): ActionCreatorProps<
  ActionFncs<S, F> & P
> {
  // @ts-ignore
  return props<ActionFncs<S, F> & P>();
}
